import { apolloClient } from "@/plugins/vue-apollo.js";

const createLandmark = (_variables) => {
  // , limit, skip
  let responseFromApi;
  let variables = _variables;
  responseFromApi = apolloClient
    .mutate({
      mutation: require("@/settings/api/mutations/landmark/create_landmark.graphql"),
      variables: variables,
      update: (store, { data }) => {
        const query = {
          query: require("@/settings/api/queries/landmark/get_landmark_query.graphql"),
          variables: {
            input: {
              limit: 10,
              skip: 0
            }
            // ,
            // filter: {
            //   searchKey: ''
            // }
          }
        };
        let allLandmark = store.readQuery(query);
        allLandmark.getLandmarks.landmarks.unshift(data.createLandmark); //push to top
        store.writeQuery({
          ...query,
            data: allLandmark,
        });
      }
    })
    .catch(error => {
      return error;
    });
  return responseFromApi;
};
export { createLandmark };
